import Vue from 'vue';

const success = (response, context) => {
    context.reviewsUrls = response.data.reviewsUrls;
    context.rentals = response.data.rentals;
    context.reviewsComments = response.data.reviews.realReviews;
    context.avgReviews = response.data.reviews.avgReviews;

    if (!context.isFromMounted) {
      context.loading = false;
    }
    context.isFromMounted = false;
};

const failed = (error, context) => {
    if (!context.isFromMounted) {
      context.loading = false;
    }
    context.isFromMounted = false;
    context.showToasterError(error);
};

export default (url, context) => {
    return Vue.$http.get(url)
        .then((response) => {
            if (response && response.status === 200) {
                success(response, context);
            }
    })
    .catch((error) => {
        failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/analytics/getReviewsTab.js